import React from 'react'

const Flag = ({image, isSelected, ...props}:{image: any, isSelected: any, [x: string]: any}) => (
  <img alt="flag" id="Flags" src={image} className={isSelected ? 'flag selected' : 'flag'} {...props}/>
)

export default Flag